<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">
        <div class="vl-toolbar">
          <input class="vl-input" type="search" placeholder="Cari judul, channel, atau kode&hellip;"
                 aria-label="Cari video" [value]="isKeyword"
                 (input)="onKeywordInput($event.target.value)" (keyup.enter)="applyFilter()">
          <div class="vl-spacer"></div>
          <button type="button" class="vl-btn-primary" (click)="onShowAdd()"
                  data-bs-toggle="modal" data-bs-target="#formData">+ Tambah Video</button>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <div class="vl-card">
              <div class="vl-loading" *ngIf="isTableLoading">
                <img src="assets/images/preloaders/3.svg" class="vl-loading-img" alt="Memuat data">
              </div>
              <div class="vl-scroll">
              <table class="vl-table">
                <thead>
                <tr>
                  <th class="vl-num">No</th>
                  <th>Video</th>
                  <th>Judul</th>
                  <th>Channel</th>
                  <th>Kode</th>
                  <th>Waktu Upload</th>
                  <th class="text-right">Aksi</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let v of isData; let i = index" class="vl-row" [class.vl-alt]="i % 2 == 1">
                  <th class="vl-num">{{rowNo(i)}}</th>
                  <td>
                    <button *ngIf="v.thumbUrl" type="button" title="Putar video" class="vv-link" (click)="openPlayer(v)">
                      <img [src]="v.thumbUrl" alt="{{v.title}}" class="vv-thumb">
                      <span class="vv-play"><i class="fa fa-play"></i></span>
                    </button>
                    <span *ngIf="!v.thumbUrl" class="vl-muted">&mdash;</span>
                  </td>
                  <td class="vv-title">
                    <span class="vl-name vv-title-text" [class.open]="v.showFull" [innerHTML]="highlight(v.title)"></span>
                    <button type="button" class="vf-more" *ngIf="v.title && v.title.length > 80"
                            (click)="v.showFull = !v.showFull">
                      {{v.showFull ? 'Sembunyikan' : 'Selengkapnya'}}</button>
                  </td>
                  <td class="vl-muted" [innerHTML]="highlight(v.description)"></td>
                  <td>
                    <span class="vl-code-wrap">
                      <code class="vl-code" [innerHTML]="highlight(v.code)"></code>
                      <button type="button" class="vl-copy" title="Salin kode" (click)="copyText(v.code)">
                        <i class="fa fa-copy"></i></button>
                    </span>
                  </td>
                  <td class="vl-muted vl-small">{{v.createdVw}}</td>
                  <td>
                    <div class="vl-actions">
                      <button type="button" class="vl-icon" title="Edit" (click)="onEdit(v)" data-bs-toggle="modal"
                              data-bs-target="#formData"><i class="fa fa-edit"></i></button>
                      <button type="button" class="vl-icon danger" title="Hapus" (click)="onDelete(v)"><i class="fa fa-trash"></i></button>
                    </div>
                  </td>
                </tr>
                <tr *ngIf="!isData.length">
                  <td colspan="7" class="vl-empty">Tidak ada data</td>
                </tr>
                </tbody>
              </table><!--end /table-->
              </div>
              <div class="vl-foot">
                <span class="vl-summary">Menampilkan <b>{{formatNumber(summaryFrom())}}&ndash;{{formatNumber(summaryTo())}}</b> dari <b>{{formatNumber(isTotalAll)}}</b> video</span>
                <div class="vl-spacer"></div>
                <nav class="vl-pager" aria-label="Navigasi halaman">
                  <button type="button" class="vl-page" [disabled]="isPage == 1" (click)="goToPage(isPage - 1)">&lsaquo;</button>
                  <ng-container *ngFor="let p of isPages">
                    <span *ngIf="p == '...'" class="vl-ellipsis">&hellip;</span>
                    <button *ngIf="p != '...'" type="button" class="vl-page" [class.active]="p == isPage"
                            (click)="goToPage(p)">{{p}}</button>
                  </ng-container>
                  <button type="button" class="vl-page" [disabled]="isPage == totalPages()" (click)="goToPage(isPage + 1)">&rsaquo;</button>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- FORM -->
<form [formGroup]="isForm" (ngSubmit)="onSubmit()">
  <div class="modal fade" id="formData" aria-labelledby="formDataLabel" aria-hidden="true" data-keyboard="false"
       data-backdrop="static">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header vf-header">
          <div>
            <h6 class="modal-title vf-title" id="formDataLabel">{{isForm.value.id ? 'Edit video' : 'Tambah video'}}</h6>
            <div class="vf-subtitle">{{isForm.value.id ? 'Perbarui detail video ini.' : 'Tautkan video YouTube ke aplikasi.'}}</div>
          </div>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" [disabled]="isLoading"></button>
        </div>
        <div class="modal-body">
          <div class="vf-grid">
            <div class="vf-field full">
              <label class="vf-label">Judul <span class="req">*</span></label>
              <input type="text" class="vf-input" [class.invalid]="isInvalid('title')"
                     placeholder="Judul video" formControlName="title">
              <div class="vf-error" *ngIf="isInvalid('title')">Judul wajib diisi.</div>
            </div>
            <div class="vf-field full">
              <label class="vf-label">Channel <span class="req">*</span></label>
              <input type="text" class="vf-input" [class.invalid]="isInvalid('description')"
                     placeholder="Nama channel" formControlName="description">
              <div class="vf-error" *ngIf="isInvalid('description')">Channel wajib diisi.</div>
            </div>
            <div class="vf-field full">
              <label class="vf-label">Kode YouTube <span class="req">*</span></label>
              <input type="text" class="vf-input vf-mono" [class.invalid]="isInvalid('code')"
                     placeholder="Misal: dQw4w9WgXcQ" formControlName="code">
              <div class="vf-hint">Kode di belakang <code class="vf-hint-code">youtube.com/watch?v=</code> pada URL video.</div>
              <div class="vf-error" *ngIf="isInvalid('code')">Kode video wajib diisi.</div>
            </div>
            <div class="vf-field full" *ngIf="formThumb()">
              <label class="vf-label">Pratinjau</label>
              <img [src]="formThumb()" alt="Pratinjau video" class="vf-preview">
            </div>
          </div>
        </div>
        <div class="modal-footer vf-footer">
          <button type="button" class="vl-btn-ghost" data-bs-dismiss="modal" [disabled]="isLoading">Batal</button>
          <button type="submit" class="vl-btn-primary" [disabled]="isLoading">
            <i class="fa fa-spinner fa-spin" *ngIf="isLoading"></i> Simpan</button>
        </div>
      </div>
    </div>
  </div>
</form>

<!-- video player dialog: YouTube embed, click anywhere or Escape closes -->
<div class="vb-viewer" *ngIf="isPlayerUrl" (click)="closePlayer()">
  <div class="vv-frame" (click)="$event.stopPropagation()">
    <div class="vv-embed">
      <iframe [src]="isPlayerUrl" [title]="isPlayerTitle"
              allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowfullscreen frameborder="0"></iframe>
    </div>
    <div class="vv-bar">
      <span class="vv-bar-title">{{isPlayerTitle}}</span>
      <a [href]="isPlayerWatch" target="_blank" rel="noopener" class="vv-bar-link">Buka di YouTube <i class="fa fa-external-link-alt"></i></a>
    </div>
  </div>
  <button type="button" class="vb-viewer-close" title="Tutup" aria-label="Tutup">&times;</button>
</div>

<!-- delete confirmation dialog (custom, design-system styled) -->
<div class="hds-overlay" *ngIf="isConfirm" (click)="closeConfirm()">
  <div class="hds-dialog" role="alertdialog" aria-modal="true" (click)="$event.stopPropagation()">
    <div class="hds-a">
      <span class="hds-ico">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
             stroke-linejoin="round"><path d="M3 6h18M8 6V4h8v2m-9 0l1 14h8l1-14"/></svg>
      </span>
      <h3>Hapus video ini?</h3>
      <p>Tindakan ini tidak bisa dibatalkan.</p>
      <div class="hds-item">
        <img *ngIf="isConfirm.v.thumbUrl" [src]="isConfirm.v.thumbUrl" alt="" class="hds-thumb">
        <span class="hds-item-text">{{isConfirm.v.title}}</span>
      </div>
    </div>
    <div class="hds-foot hds-foot-full">
      <button type="button" class="vl-btn-ghost" [disabled]="isDeleting" (click)="closeConfirm()">Batal</button>
      <button type="button" class="hds-btn-danger" [disabled]="isDeleting" (click)="confirmDelete()">
        <i class="fa fa-spinner fa-spin" *ngIf="isDeleting"></i> Hapus</button>
    </div>
  </div>
</div>
